/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FieldChangedEvent } from './FieldChangedEvent';
import {
    FieldChangedEventFromJSON,
    FieldChangedEventFromJSONTyped,
    FieldChangedEventToJSON,
} from './FieldChangedEvent';
import type { FieldCreatedEvent } from './FieldCreatedEvent';
import {
    FieldCreatedEventFromJSON,
    FieldCreatedEventFromJSONTyped,
    FieldCreatedEventToJSON,
} from './FieldCreatedEvent';
import type { FieldDeletedEvent } from './FieldDeletedEvent';
import {
    FieldDeletedEventFromJSON,
    FieldDeletedEventFromJSONTyped,
    FieldDeletedEventToJSON,
} from './FieldDeletedEvent';

/**
 * Schema change event configuration for all objects in the integration.
 * @export
 * @interface WatchSchemaAllObjects
 */
export interface WatchSchemaAllObjects {
    /**
     * 
     * @type {FieldCreatedEvent}
     * @memberof WatchSchemaAllObjects
     */
    fieldCreated?: FieldCreatedEvent;
    /**
     * 
     * @type {FieldDeletedEvent}
     * @memberof WatchSchemaAllObjects
     */
    fieldDeleted?: FieldDeletedEvent;
    /**
     * 
     * @type {FieldChangedEvent}
     * @memberof WatchSchemaAllObjects
     */
    fieldChanged?: FieldChangedEvent;
}

/**
 * Check if a given object implements the WatchSchemaAllObjects interface.
 */
export function instanceOfWatchSchemaAllObjects(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WatchSchemaAllObjectsFromJSON(json: any): WatchSchemaAllObjects {
    return WatchSchemaAllObjectsFromJSONTyped(json, false);
}

export function WatchSchemaAllObjectsFromJSONTyped(json: any, ignoreDiscriminator: boolean): WatchSchemaAllObjects {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fieldCreated': !exists(json, 'fieldCreated') ? undefined : FieldCreatedEventFromJSON(json['fieldCreated']),
        'fieldDeleted': !exists(json, 'fieldDeleted') ? undefined : FieldDeletedEventFromJSON(json['fieldDeleted']),
        'fieldChanged': !exists(json, 'fieldChanged') ? undefined : FieldChangedEventFromJSON(json['fieldChanged']),
    };
}

export function WatchSchemaAllObjectsToJSON(value?: WatchSchemaAllObjects | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fieldCreated': FieldCreatedEventToJSON(value.fieldCreated),
        'fieldDeleted': FieldDeletedEventToJSON(value.fieldDeleted),
        'fieldChanged': FieldChangedEventToJSON(value.fieldChanged),
    };
}

